module.exports = __webpack_public_path__ + "img/hot.e48062b8.png";